const formatDate_DDMMYY = (date?: Date): string => {
  return !date
    ? ""
    : (date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`) +
    "/" +
    (date.getMonth() + 1 > 9
      ? date.getMonth() + 1
      : `0${date.getMonth() + 1}`) +
    "/" +
    date.getFullYear();
};

/**Fomato de 21/07/2024 a 21-07-2024 de */
const formatDate_DDMYY_guion = (fecha?: string): Date | undefined => {
  if (fecha) {
    const [day, month, year] = fecha.split("/");
    const date = new Date(+year, +month - 1, +day);
    return date;
  } else {
    return undefined;
  }
};

/**Fomato de 2022/07/02 a 21-07-2024 de */
const formatDate_YYMMDD_guion = (fecha?: string): Date | undefined => {
  if (fecha) {
    const [day, month, year] = fecha.split(",");
    const date = new Date(+year, +month - 1, +day);
    return date;
  } else {
    return undefined;
  }
};
const formatDate_guion = (fecha?: string): Date | undefined => {
  if (fecha) {
    const [year, month, day] = fecha.split(",");
    const date = new Date(+year, +month - 1, +day);
    return date;
  } else {
    return undefined;
  }
};
const formatGuionFecha= (fecha:string,esHasta:boolean):Date | undefined =>{
  if (!/^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
    return undefined;
  }
  const [year, month, day] = fecha.split('-').map(num => parseInt(num, 10));
  let date = new Date(year, month - 1, day);
  if(esHasta){
    date = new Date(year, month - 1, day, 23, 59, 59, 999);
  }
  if (isNaN(date.getTime())) {
    return undefined;
  }
  
  return date;
}

const onFormatDate = (date?: Date): string => {
  return !date
    ? ""
    : date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
};

/**Convierte el DATE a  un String separado por comas "2022,12,03" */
const formatDate_YYMMDD_comas = (date?: Date): string => {
  return !date
    ? ""
    : date.getFullYear() +
    "," +
    (date.getMonth() + 1 > 9
      ? date.getMonth() + 1
      : `0${date.getMonth() + 1}`) +
    "," +
    (date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`);
};
const _formatDate = (date: Date, format: string) => {
  let s = "";

  switch (format) {
    case ",":
      s = `${date.getFullYear()},${date.getMonth() + 1},${date.getDate()}`;
      break;
    case "/":
      s = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
      break;
    case "-":
      s = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      break;
    default:
      break;
  }

  return s;
};

// De 2024-06-01T05:00:00.000Z a 01/06/2024
const formatDateStr_DDMMYY = (dateString: string) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

//*Devuelve el primer día del mes actual (o del mes de la fecha proporcionada) 
const getPrimerDiaDelMes = (fecha?: Date): Date => {
  const date = fecha || new Date();
  return new Date(date.getFullYear(), date.getMonth(), 1);
};

//*Devuelve el último día del mes actual (o del mes de la fecha proporcionada) 
const getUltimoDiaDelMes = (fecha?: Date): Date => {
  const date = fecha || new Date();
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
};

/*
 * Obtiene la fecha/hora actual según la zona horaria del usuario.
 * Si el usuario está en Cusco, detectará "America/Lima" (Perú).
 * Si está en Madrid, detectará "Europe/Madrid".
 * Si está en Nueva York, detectará "America/New_York".
 * Siempre tendrás la fecha/hora correcta según la hora horaria real del usuario.
 * Evita tomar la hora del ordenador que puede estar mal configurada.
 */
const ObtenerFechaSegunLugar = (): Date => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone; // o zona fija como 'America/Lima'
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }).formatToParts(new Date());
  
  const v = Object.fromEntries(parts.map((p) => [p.type, p.value]));
  
  return new Date(Date.UTC(
    parseInt(v.year, 10),
    parseInt(v.month, 10) - 1,
    parseInt(v.day, 10),
    parseInt(v.hour, 10),
    parseInt(v.minute, 10),
    parseInt(v.second, 10)
  ));
};



export {
  formatDate_DDMMYY,
  formatDate_DDMYY_guion,
  onFormatDate,
  formatDate_YYMMDD_comas,
  formatDate_YYMMDD_guion,
  _formatDate,
  formatDate_guion,
  formatDateStr_DDMMYY,
  formatGuionFecha,
  getPrimerDiaDelMes,
  getUltimoDiaDelMes,
  ObtenerFechaSegunLugar
};
